import Loadable from "react-loadable";

const LazyView = Loadable({
  loader: () => import(/* webpackChunkName: 'livrable-view' */ "./view"),
  loading: () => 'loading...'
});

export default LazyView;
